var _path, _path2, _g, _path3, _path4, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTokenExpiryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.175 10.45L14.55 4.6C14.25 3.775 13.425 3.25 12.525 3.25H5.475C4.575 3.25 3.75 3.775 3.45 4.6L0.825 10.45C0.75 10.525 0.75 10.675 0.75 10.75V14.5C0.75 15.775 1.725 16.75 3 16.75H15C16.275 16.75 17.25 15.775 17.25 14.5V10.75C17.25 10.675 17.25 10.525 17.175 10.45ZM4.8 5.2C4.875 4.9 5.175 4.75 5.475 4.75H12.525C12.825 4.75 13.125 4.9 13.2 5.2L15.3 10H12C11.775 10 11.55 10.15 11.4 10.3L10.125 12.25H7.95L6.675 10.3C6.45 10.15 6.225 10 6 10H2.625L4.8 5.2ZM3 15.25H15C15.45 15.25 15.75 14.95 15.75 14.5V11.5H12.375L11.1 13.45C10.95 13.6 10.725 13.75 10.5 13.75H7.5C7.275 13.75 7.05 13.6 6.9 13.45L5.625 11.5H2.25V14.5C2.25 14.95 2.55 15.25 3 15.25Z",
    fill: "#3E556D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20880_14490",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 18,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.175 10.45L14.55 4.6C14.25 3.775 13.425 3.25 12.525 3.25H5.475C4.575 3.25 3.75 3.775 3.45 4.6L0.825 10.45C0.75 10.525 0.75 10.675 0.75 10.75V14.5C0.75 15.775 1.725 16.75 3 16.75H15C16.275 16.75 17.25 15.775 17.25 14.5V10.75C17.25 10.675 17.25 10.525 17.175 10.45ZM4.8 5.2C4.875 4.9 5.175 4.75 5.475 4.75H12.525C12.825 4.75 13.125 4.9 13.2 5.2L15.3 10H12C11.775 10 11.55 10.15 11.4 10.3L10.125 12.25H7.95L6.675 10.3C6.45 10.15 6.225 10 6 10H2.625L4.8 5.2ZM3 15.25H15C15.45 15.25 15.75 14.95 15.75 14.5V11.5H12.375L11.1 13.45C10.95 13.6 10.725 13.75 10.5 13.75H7.5C7.275 13.75 7.05 13.6 6.9 13.45L5.625 11.5H2.25V14.5C2.25 14.95 2.55 15.25 3 15.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20880_14490)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1H18V19H0V1Z",
    fill: "#3E556D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7918 6.125L9.29183 8.625C9.25016 8.66667 9.2085 8.70833 9.16683 8.70833C9.12516 8.75 9.04183 8.75 9.00016 8.75C8.9585 8.75 8.87516 8.75 8.8335 8.70833C8.79183 8.66667 8.75016 8.66667 8.7085 8.625L6.2085 6.125C6.04183 5.95833 6.04183 5.70833 6.2085 5.54167C6.37516 5.375 6.62516 5.375 6.79183 5.54167L8.5835 7.33333V1.66667C8.5835 1.41667 8.75016 1.25 9.00016 1.25C9.25016 1.25 9.41683 1.41667 9.41683 1.66667V7.33333L11.2085 5.54167C11.3752 5.375 11.6252 5.375 11.7918 5.54167C11.9585 5.70833 11.9585 5.95833 11.7918 6.125Z",
    fill: "#3E556D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20880_14490",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 6,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7918 6.125L9.29183 8.625C9.25016 8.66667 9.2085 8.70833 9.16683 8.70833C9.12516 8.75 9.04183 8.75 9.00016 8.75C8.9585 8.75 8.87516 8.75 8.8335 8.70833C8.79183 8.66667 8.75016 8.66667 8.7085 8.625L6.2085 6.125C6.04183 5.95833 6.04183 5.70833 6.2085 5.54167C6.37516 5.375 6.62516 5.375 6.79183 5.54167L8.5835 7.33333V1.66667C8.5835 1.41667 8.75016 1.25 9.00016 1.25C9.25016 1.25 9.41683 1.41667 9.41683 1.66667V7.33333L11.2085 5.54167C11.3752 5.375 11.6252 5.375 11.7918 5.54167C11.9585 5.70833 11.9585 5.95833 11.7918 6.125Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20880_14490)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0H14V10H4V0Z",
    fill: "#3E556D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenExpiryIcon);
export default __webpack_public_path__ + "static/media/TokenExpiryIcon.99078b383c423035f6299ce869ab4cce.svg";
export { ForwardRef as ReactComponent };